import React from 'react';
import axios from 'axios';
import { Post } from './post.component';

import './related-posts.styles.scss';
import { Link } from 'react-router-dom';

function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

class RelatedPosts extends React.Component {
    constructor(){
        super();

        this.state = {
            data: []
        }
    }

    componentDidMount(){
        axios.get(`https://crowdriff.com/wp-json/wp/v2/showcase?per_page=100`)
            .then(res => this.setState({
                data: res.data
            }))
            .catch(err => console.log(err))
    }

    render(){
        const caseStudies = this.state.data.filter(item => item.acf.case_study_boolean && !item.slug.includes(this.props.thisSlug))
        shuffle(caseStudies);

        if (caseStudies.length > 0) {
            return (
                <div className="related-posts">
                    <div className="container">
                        <h2>How Other DMOs are using CrowdRiff</h2>
                        <ul className="posts-wrapper">
                            {
                                caseStudies.slice(0,3).map((post, i) => (
                                    <Post 
                                        key={i}
                                        image={post.acf.image}
                                        title={post.title.rendered}
                                        url={post.slug}
                                    />
                                ))
                            }
                        </ul>
                        <div className="btn-wrapper">
                            <Link to="/tourism-community-stories/#crowdriff-use-case" className="btn btn-hollow">View All</Link>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }
}

export default RelatedPosts;